export default {
      id: "oc-large-page-memory-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-large-page-memory",
      toString: function () {
        return this.url;
      }
    }